const PL_LOCATION_SUMMARY_SEGMENT = "podsumowanie-lokalizacji";
const EN_LOCATION_SUMMARY_SEGMENT = "location-summary";
const PL_PROJECTS_MAP_SEGMENT = "mapa-projektow";
const EN_PROJECTS_MAP_SEGMENT = "projects-map";

const PL_FLATS_SEGMENTS = new Set([
    "fltr",
    PL_PROJECTS_MAP_SEGMENT,
    PL_LOCATION_SUMMARY_SEGMENT,
    "ceny",
    "oferta",
    "popyt",
    "sprzedane",
    "nowe"
]);
const PL_PROPERTIES_SEGMENTS = new Set([
    PL_PROJECTS_MAP_SEGMENT,
    PL_LOCATION_SUMMARY_SEGMENT,
    "ceny",
    "oferta",
    "popyt",
    "sprzedane",
    "nowe"
]);
const PL_HOUSES_SEGMENTS = new Set([PL_PROJECTS_MAP_SEGMENT, PL_LOCATION_SUMMARY_SEGMENT]);
const EN_FLATS_SEGMENTS = new Set([
    "fltr",
    EN_PROJECTS_MAP_SEGMENT,
    EN_LOCATION_SUMMARY_SEGMENT,
    "prices",
    "offer",
    "demand",
    "sold",
    "added"
]);
const EN_PROPERTIES_SEGMENTS = new Set([
    EN_PROJECTS_MAP_SEGMENT,
    EN_LOCATION_SUMMARY_SEGMENT,
    "prices",
    "offer",
    "demand",
    "sold",
    "added"
]);
const EN_HOUSES_SEGMENTS = new Set([EN_PROJECTS_MAP_SEGMENT, EN_LOCATION_SUMMARY_SEGMENT]);

interface IOfferRootConfig {
    prefix: string;
    dashboardSegment: string;
    knownSegments: Set<string>;
    /** City-slug URLs under this prefix 301 here instead of stripping to the projects map. */
    landingPath?: string;
}

const OFFER_ROOTS: IOfferRootConfig[] = [
    {
        prefix: "/ceny/mieszkania/",
        dashboardSegment: PL_PROJECTS_MAP_SEGMENT,
        knownSegments: PL_FLATS_SEGMENTS,
        landingPath: "/rozwiazania/platforma-analityczna/"
    },
    {prefix: "/ceny/nieruchomosci/", dashboardSegment: PL_PROJECTS_MAP_SEGMENT, knownSegments: PL_PROPERTIES_SEGMENTS},
    {
        prefix: "/ceny/domy/",
        dashboardSegment: PL_PROJECTS_MAP_SEGMENT,
        knownSegments: PL_HOUSES_SEGMENTS,
        landingPath: "/rozwiazania/platforma-analityczna/"
    },
    {
        prefix: "/en/prices/flats/",
        dashboardSegment: EN_PROJECTS_MAP_SEGMENT,
        knownSegments: EN_FLATS_SEGMENTS,
        landingPath: "/en/solutions/analytical-platform/"
    },
    {
        prefix: "/en/prices/properties/",
        dashboardSegment: EN_PROJECTS_MAP_SEGMENT,
        knownSegments: EN_PROPERTIES_SEGMENTS
    },
    {
        prefix: "/en/prices/houses/",
        dashboardSegment: EN_PROJECTS_MAP_SEGMENT,
        knownSegments: EN_HOUSES_SEGMENTS,
        landingPath: "/en/solutions/analytical-platform/"
    }
];

/**
 * Maps legacy `/…/:citySlug/…` chart URLs to a 301 target.
 * Flats/houses city trees go to the analytical-platform landing; properties still strip to the projects map.
 */
export const stripLegacyCityFromPathname = (pathname: string): string | null => {
    for (const {prefix, dashboardSegment, knownSegments, landingPath} of OFFER_ROOTS) {
        if (!pathname.startsWith(prefix)) {
            continue;
        }

        const remainder = pathname.slice(prefix.length);
        if (!remainder) {
            continue;
        }

        const segments = remainder.split("/").filter(Boolean);
        const firstSegment = segments[0];

        if (!firstSegment || knownSegments.has(firstSegment)) {
            continue;
        }

        if (landingPath != null) {
            return landingPath !== pathname ? landingPath : null;
        }

        const tail = segments.slice(1).join("/");
        const nextPath = tail ? `${prefix}${tail}/` : `${prefix}${dashboardSegment}/`;

        return nextPath !== pathname ? nextPath : null;
    }

    return null;
};
